// extracted by css-extract-rspack-plugin
export default {"data-hook-wrapper":"_Hgods","dataHookWrapper":"_Hgods"};